import {atom} from "jotai/index";
import {useCallback} from "react";
import {useAtom} from "jotai";
import {AnalysisOptionsDep} from "../../../2-option-selection/AnalysisOptions.ts";

export interface ProgressInfo {
    id: string
    report: (completed: number, total: number) => void
    reportOne: () => void
    complete: () => void
}

export interface ActionProgress {
    id: string
    action: string
    completed: number
    total: number
}

const ScanActionsAtom = atom<ActionProgress[]>([])
export type StartAction = (action: string, totalCount: number) => ProgressInfo

// If we change the options, we clear the scan actions
AnalysisOptionsDep((set) => {
    set(ScanActionsAtom, [])
})

export function useScanActions(): [ActionProgress[], StartAction] {
    const [activeActions, setActiveActions] = useAtom(ScanActionsAtom)

    const startAction = useCallback<StartAction>((action, totalCount) => {
        const id = `action-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`

        const newAction: ActionProgress = {
            id,
            action,
            completed: 0,
            total: totalCount
        }

        setActiveActions((old) => [...old, newAction])

        function report(completed: number, total: number) {
            setActiveActions((old) =>
                old.map((actionProgress) =>
                    actionProgress.id === id
                        ? { ...actionProgress, completed, total }
                        : actionProgress
                )
            )
        }

        function reportOne() {
            setActiveActions((old) =>
                old.map((actionProgress) =>
                    actionProgress.id === id
                        ? { ...actionProgress, completed: actionProgress.completed + 1 }
                        : actionProgress
                )
            )
        }

        function complete() {
            setActiveActions((old) => old.filter((actionProgress) => actionProgress.id !== id))
        }

        return {
            id,
            report,
            reportOne,
            complete
        }
    }, [setActiveActions])

    return [activeActions, startAction]
}